import { ColumnType } from "antd/lib/table";
import { formatarDataSemTimezone, limitarCaracteres } from "../ModalPlanejamentoOperacoes/utils";
import StatusTag from "./StatusTag";

const columns = (): ColumnType<any>[] => {
  let columnsShow: ColumnType<any>[] = [
    {
      title: "Código do Planejamento",
      dataIndex: "planoOperacionalCodigo",
      align: "center",
      width: 150,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Descrição do Planejamento",
      dataIndex: "planoOperacionalDescricao",
      align: "center",
      width: 180,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{limitarCaracteres(value, 30) ?? "-"}</span>,
    },
    {
      title: "Fazenda",
      dataIndex: "fazenda",
      align: "center",
      width: 80,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Setor",
      dataIndex: "setor",
      align: "center",
      width: 100,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Talhão",
      dataIndex: "talhao",
      align: "center",
      width: 60,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Sequência",
      dataIndex: "sequencia",
      align: "center",
      width: 80,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Classe de Operação",
      dataIndex: "operacaoClasse",
      align: "center",
      width: 120,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{limitarCaracteres(value, 25) ?? "-"}</span>,
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      width: 130,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{limitarCaracteres(value, 25) ?? "-"}</span>,
    },
    {
      title: "Status da Operação",
      dataIndex: "status",
      align: "center",
      width: 140,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}><StatusTag status={value} /></span>,
    },
    {
      title: "Área Planejada",
      dataIndex: "areaPlanejada",
      align: "center",
      width: 110,
      render: (value: number) => <span style={{ fontSize: 13 }}>{value ? value.toFixed(2).replace(".", ",") : "-"}</span>,
    },
    {
      title: "Área Executada",
      dataIndex: "areaExecutada",
      align: "center",
      width: 110,
      render: (value: number) => <span style={{ fontSize: 13 }}>{value ? value.toFixed(2).replace(".", ",") : "-"}</span>,
    },
    {
      title: "Alvo",
      dataIndex: "alvo",
      align: "center",
      width: 80,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{limitarCaracteres(value, 25) ?? "-"}</span>,
    },
    {
      title: "Ordem de Serviço",
      dataIndex: "ordemServico",
      align: "center",
      width: 130,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{limitarCaracteres(value, 25) ?? "-"}</span>,
    },
    {
      title: "Data Programada",
      dataIndex: "dataProgramada",
      align: "center",
      width: 110,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{formatarDataSemTimezone(value) ?? "-"}</span>,
    },
    {
      title: "Data Reprogramada",
      dataIndex: "dataReprogramada",
      align: "center",
      width: 140,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{formatarDataSemTimezone(value) ?? "-"}</span>,
    },
    {
      title: "Data Realizada",
      dataIndex: "dataExecucao",
      align: "center",
      width: 130,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{formatarDataSemTimezone(value) ?? "-"}</span>,
    },
  ];

  return columnsShow;
}
export default columns;
